 import { useThemeMode } from "@/hooks/useThemeMode";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

 const Toaster = ({ ...props }: ToasterProps) => {
   const { themeColor } = useThemeMode();

  return (
    <Sonner
      theme={themeColor as ToasterProps["theme"]}
      className="toaster group"
      position="bottom-center"
      offset="calc(env(safe-area-inset-bottom, 0px) + 80px)"
      style={{ width: "100%" }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
